// src/components/NoteItem.jsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Note } from 'types/notes';
import { isNoteViewedToday } from 'utils/dailyViewTracker';

interface NotesIndexNoteItemProps {
  note: Note;
  pboard?: string;
};

const NotesIndexNoteItem = ({ note, pboard }: NotesIndexNoteItemProps) => {
  const note_url = `/notes/${pboard || note.pbid || 'notes'}/${note.id}`;
  const isViewed = isNoteViewedToday(note.id);

  return (
    // opacity-90
    <div className={`card bg-base-100 border border-gray-200 min-h-[6rem] w-full md:w-80 bg-cover bg-top cursor-pointer relative ${isViewed ? '' : ''}`}>
      {isViewed && (
        <div className="absolute top-2 right-2 z-10 bg-green-500 text-white text-xs px-2 py-1 rounded-full">
          ✓읽음
        </div>
      )}
      <figure className="min-h-[14rem] max-h-[14rem] overflow-hidden p-0 mb-0 flex flex-col items-start p-0 mb-0 not-prose block">
        {/* filter grayscale */}
        <Link to={note_url}>
        { note.image_url ?
          <img src={note.image_url} alt={note.title} className={isViewed ? '' : ''} /> :
          <img src="https://placehold.co/400x300" alt={note.title} className={isViewed ? '' : ''} />
        }
        </Link>
      </figure>
      <div className="card-body p-4 flex flex-col justify-between">
        <div>
          {/* text-gray-500 */}
          <h2 className={`card-title text-lg mb-2 text-gray-800}`}>
            <Link to={note_url}>{note.title}</Link>
          </h2>
          {/* text-gray-400 */}
          <p className={`text-sm mb-4 line-clamp-3 text-gray-800}`}>
            {note.description}
          </p>
        </div>
        <div className="card-actions justify-end text-sm text-gray-400">
          {/* You can make the whole card clickable or add a specific button */}
          {/* For simplicity, let's assume clicking the card body leads to the note */}
           {/* Or add a button like this: */}
           {/* <button className="btn btn-primary btn-sm">더보기</button> */}
        </div>
         {/* Optional: Make the whole card clickable using an overlay link */}
         {/* <a href={`/notes/${note.id}`} className="absolute inset-0"></a> */}
      </div>
    </div>
  );
};

export default NotesIndexNoteItem;
